// The chosen mailbox and folder of the mail client (R-M6), shared by the folders in the frame's left column and the screen of letters:
// the column stays the same on the pages of letters the system sends, templates and mailings (um/2026-10-30/03 п.1).

import { useSyncExternalStore } from 'react';
import type { Id } from '@confdeck/core-shared';
import type { View } from './model.ts';

export interface MailNavState {
  box: Id | 'all';
  view: View;
  /** A request of the column the screen carries out: a new letter, connecting or setting up a mailbox. `n` makes a repeat new. */
  ask: { kind: 'compose' } | { kind: 'connect'; id: Id | null } | null;
  n: number;
}

let state: MailNavState = { box: 'all', view: 'inbox', ask: null, n: 0 };
const listeners = new Set<() => void>();
export function setMailNav(change: Partial<MailNavState>) {
  state = { ...state, ...change, n: change.ask ? state.n + 1 : state.n };
  for (const l of listeners) l();
}
export const useMailNav = () => useSyncExternalStore((cb) => { listeners.add(cb); return () => listeners.delete(cb); }, () => state);
